export enum DailerMessageE {
  CALL = 'call',
  IN_CALL = 'inCall',
  RECEIVED_CALL = 'receivedCall',
  MUTED = 'muted',
  UNMUTED = 'unmuted',
  HOLD = 'hold',
  UNHOLD = 'unhold',
  REGISTERED = 'registered',
  END_CALL = 'endCall',
  FAILED = 'failed',
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  UNREGISTERED = 'unregistered',
  HANGUP = 'hangup',
}
